// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-form-item[data-v-41f21237] {\n  margin-bottom: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
